exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-sv-js": () => import("./../../../src/pages/index.sv.js" /* webpackChunkName: "component---src-pages-index-sv-js" */)
}

